// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.information-system-map {
    width: 100%;
}

.information-system-map__state {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    background: #ffffff;
}

.information-system-map__state--error {
    border-color: #dc3545;
    color: #dc3545;
}

.information-system-map__canvas-wrapper {
    width: 100%;
    overflow: auto;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}

.information-system-map__canvas {
    display: block;
    min-width: 100%;
}

.information-system-map__layer-label {
    fill: #495057;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.04rem;
    text-transform: uppercase;
}

.information-system-map__link {
    fill: none;
    stroke: #6c757d;
    stroke-width: 2;
    stroke-linejoin: round;
    stroke-linecap: round;
    opacity: 0.75;
}

.information-system-map__node-card {
    width: 230px;
    min-height: 78px;
    padding: 0.75rem;
    border: 1px solid #ced4da;
    border-left-width: 0.35rem;
    border-radius: 0.6rem;
    background: #ffffff;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.08);
    cursor: pointer;
}

.information-system-map__node-card:hover {
    border-color: #dc3545;
}

.information-system-map__node-card--application {
    border-left-color: #198754;
}

.information-system-map__node-card--gateway {
    border-left-color: #6f42c1;
}

.information-system-map__node-card--orchestrator {
    border-left-color: #d63384;
}

.information-system-map__node-card--engine {
    border-left-color: #fd7e14;
}

.information-system-map__node-card--repository {
    border-left-color: #0dcaf0;
}

.information-system-map__node-card--other {
    border-left-color: #6c757d;
}

.information-system-map__node-title {
    font-weight: 700;
    color: #212529;
    margin-bottom: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.information-system-map__node-metadata {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
}

.information-system-map__node-tag {
    display: inline-block;
    max-width: 100%;
    padding: 0.1rem 0.35rem;
    border-radius: 1rem;
    background: #e9ecef;
    color: #495057;
    font-size: 0.72rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/InformationSystemMap/InformationSystemMap.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,6DAA6D;AACjE;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;IACnB,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".information-system-map {\n    width: 100%;\n}\n\n.information-system-map__state {\n    padding: 1rem;\n    border: 1px solid #dee2e6;\n    border-radius: 0.5rem;\n    background: #ffffff;\n}\n\n.information-system-map__state--error {\n    border-color: #dc3545;\n    color: #dc3545;\n}\n\n.information-system-map__canvas-wrapper {\n    width: 100%;\n    overflow: auto;\n    border: 1px solid #dee2e6;\n    border-radius: 0.5rem;\n    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);\n}\n\n.information-system-map__canvas {\n    display: block;\n    min-width: 100%;\n}\n\n.information-system-map__layer-label {\n    fill: #495057;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.04rem;\n    text-transform: uppercase;\n}\n\n.information-system-map__link {\n    fill: none;\n    stroke: #6c757d;\n    stroke-width: 2;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n    opacity: 0.75;\n}\n\n.information-system-map__node-card {\n    width: 230px;\n    min-height: 78px;\n    padding: 0.75rem;\n    border: 1px solid #ced4da;\n    border-left-width: 0.35rem;\n    border-radius: 0.6rem;\n    background: #ffffff;\n    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.08);\n    cursor: pointer;\n}\n\n.information-system-map__node-card:hover {\n    border-color: #dc3545;\n}\n\n.information-system-map__node-card--application {\n    border-left-color: #198754;\n}\n\n.information-system-map__node-card--gateway {\n    border-left-color: #6f42c1;\n}\n\n.information-system-map__node-card--orchestrator {\n    border-left-color: #d63384;\n}\n\n.information-system-map__node-card--engine {\n    border-left-color: #fd7e14;\n}\n\n.information-system-map__node-card--repository {\n    border-left-color: #0dcaf0;\n}\n\n.information-system-map__node-card--other {\n    border-left-color: #6c757d;\n}\n\n.information-system-map__node-title {\n    font-weight: 700;\n    color: #212529;\n    margin-bottom: 0.25rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.information-system-map__node-metadata {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n}\n\n.information-system-map__node-tag {\n    display: inline-block;\n    max-width: 100%;\n    padding: 0.1rem 0.35rem;\n    border-radius: 1rem;\n    background: #e9ecef;\n    color: #495057;\n    font-size: 0.72rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
